export default __webpack_public_path__ + "static/media/2.5cab3f49.jpeg";